import { useEffect, useState } from 'react';
import { useLang } from '../context/LanguageContext';
import { useNewsData } from '../context/NewsDataContext';
import './EditionNotifyPrompt.css';

const STORAGE_KEY = 'rk-edition-notify';

function getChoice() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export default function EditionNotifyPrompt() {
  const { t } = useLang();
  const { homeFeed } = useNewsData();
  const [visible, setVisible] = useState(false);
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    setSupported('Notification' in window && Notification.permission !== 'denied');
    if (getChoice()) return;
    if (!homeFeed.editionLive) return;
    const tmr = setTimeout(() => setVisible(true), 2500);
    return () => clearTimeout(tmr);
  }, [homeFeed.editionLive]);

  const dismiss = (value) => {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
  };

  const enable = async () => {
    if (!('Notification' in window)) {
      dismiss('later');
      return;
    }
    try {
      const perm = await Notification.requestPermission();
      if (perm === 'granted') {
        dismiss('yes');
        if (homeFeed.latestPaperDate) {
          new Notification(t.editionNotifyTitle, {
            body: t.editionNotifyBody,
            icon: '/rk-logo.webp',
            tag: `edition-${homeFeed.latestPaperDate}`,
          });
        }
      } else {
        dismiss('no');
      }
    } catch {
      dismiss('later');
    }
  };

  if (!visible || !supported) return null;

  return (
    <div className="edition-notify" role="dialog" aria-labelledby="edition-notify-title" data-sub-free>
      <div className="edition-notify__card">
        <p id="edition-notify-title" className="edition-notify__title">
          {t.editionNotifyPrompt}
        </p>
        <div className="edition-notify__actions">
          <button type="button" className="edition-notify__btn edition-notify__btn--primary" onClick={enable}>
            {t.editionNotifyEnable}
          </button>
          <button type="button" className="edition-notify__btn" onClick={() => dismiss('later')}>
            {t.editionNotifyLater}
          </button>
        </div>
      </div>
    </div>
  );
}
